import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withErrorHandling, withLoader } from '@/store/thunks/thunkWrappers';
import { isAPIError } from '@/store/utils';
import { HTTP_STATUS_CONFLICT } from '@/config/apiConfig';
import type { UpdateSixPayload } from '@/types/create-six.types';
import type { UpdateSixResponseDTO } from '@/types/SixDetailDTOs';
import { fetchSixCatalogThunk } from '@/store/thunks/sixCatalog/fetchSixCatalog';

/** sixId (path param) + optional request body fields */
type UpdateSixThunkArg = { sixId: string } & UpdateSixPayload;

export const updateSixThunk = createAppAsyncThunk<
  UpdateSixResponseDTO,
  UpdateSixThunkArg
>(
  'createSix/updateSixThunk',
  withLoader(
    withErrorHandling(
      async({ sixId, ...body }: UpdateSixThunkArg, { extra, rejectWithValue, dispatch }) => {
        try {
          const updated = await extra.createSixService.updateSix(sixId, body);
          await dispatch(fetchSixCatalogThunk());
          return updated;
        } catch (error) {
          if (isAPIError(error) && error.status === HTTP_STATUS_CONFLICT) {
            return rejectWithValue({ fieldErrors: { name: 'Duplicate name' } });
          }
          throw error;
        }
      }
    )
  )
);
